import React from 'react';
import BaseGrid from '../grid/BaseGrid';
import { DASHBOARD_GRID_PROPS, DASHBOARD_GRID_STATE } from './Types';
import { Component } from '../../dispatcher/modules';
import * as _ from 'lodash';
import BaseTreeGrid from '../grid/BaseTreeGrid';
import { SortDescriptor } from '@progress/kendo-data-query';

/**
 * @class DashboardGrid
 * Default Dashboard grid
 * Implements Navigation or TreeGrid based on gridType prop with values: ['grid', 'tree'] Defaults to 'grid'
 */
export default class DashboardGrid extends Component<DASHBOARD_GRID_PROPS, DASHBOARD_GRID_STATE> {
  private gridRef: any;

  constructor(props) {
    super(props);
    this.state = {
      sort: []
    };
  }

  private setGridReference = (el: any) => {
    this.gridRef = el;
  };

  /**
   * @inheritDoc
   */
  public getFilterData = (isQuery = false) => this.gridRef.getFilterData(isQuery)

  /**
   * Return params needed for full dashboard grid request, including columns and advanced filter params
   * @param page
   */
  public getGridFilterParams = (page = 0) => this.gridRef.getGridFilterParams(page)

  /**
   * Executes expand all regardless user didn't click on toggle button
   * @param {Boolean} forceExpanded
   */
  public executeExpandAll = (forceExpanded?: boolean | undefined) => {
    if (this.props.gridType === 'tree') {
      this.gridRef.executeExpandAll(forceExpanded);
    }
  }

  /**
   * Returns selected row dataItem
   */
  getSelectedRowDataItem = () => this.gridRef.getSelectedRowDataItem()

  /**
   * Sets selected row dataItem
   * @param {any} record Row dataItem record
   */
  setSelectedRowDataItem = (record?: any) => {
    this.gridRef.setSelectedRowDataItem(record);
  }

  /**
   * Set sort in NavigationBaseGrid
   * @param {SortDescriptor[]} sort
   */
  public setSort = (sort: SortDescriptor[]):void => {
    this.gridRef.setSort(sort);
  }

  /**
   * Sets grid filters
   * @param data
   */
  public setFilterData = (data: any) => this.gridRef.setFilterData(data)

  /**
   * Reload All Grid Data
   */
  public reloadGridData = (params: object = {}, url = '', method: '', saveScroll: boolean = true) => {
    this.gridRef.reloadGridData(params, url, method, saveScroll);
  }

  /**
   * Sync Reload All Grid Data
   * @param params
   * @param url
   * @param method
   * @param saveScroll
   */
  public syncReloadGridData = async (params: object = {}, url = '', method: '', saveScroll: boolean = true) => await this.gridRef.syncReloadGridData(params, url, method, saveScroll)

  /**
   * Refreshes Grid Data
   */
  refreshGridData = (params: object = {}, url = '', method: '') => {
    this.gridRef.refreshGridData(params, url, method);
  }

  /**
   * Parse grid data before it is loaded into greed
   * @param {any[]} data
   */
  parseGridData = (data: any) => ({
    items: data.content,
    gridContentInfo: {
      totalCount: data.totalElements,
      pagedListInfo: {
        index: data.number,
        size: data.size
      }
    }
  });

  /**
   * Reconfigure grid columns
   * @param {any[]} columns
   * @param {string} gridModuleId
   */
  reconfigureColumns = (columns, gridModuleId?) => {
    if (this.props.onReconfigure) {
      this.props.onReconfigure({ columns });
    }
  };

  /**
   * Set new data with the changed list items
   * @param {string} parentId
   * @param {any} changedData
   */
  public changeListItems = (parentId:string, changedData:any):void => {
    this.gridRef.gridRef.wrapGridRef.changeListItems(parentId, changedData);
  }

  renderBody(): any {
    let { sort } = this.state;
    let { columns, gridType = 'grid' } = this.props;
    let props = {
      ...this.props,
      sort,

      parseGridData: this.props.parseGridData ? this.props.parseGridData : this.parseGridData,
      handleSelection: (e: any, options: any) => {
        if (options.hasOwnProperty('contextMenuOptions')) return;
        _.get(this, 'props.onRowSelected') && this.props.onRowSelected.bind(this)(e);
      },
      columns
    };

    return (
      <>
        {
          gridType === 'tree' ? <BaseTreeGrid
            {...props}
            ref={this.setGridReference}
          /> : <BaseGrid
            {...props}
            ref={this.setGridReference}
          />
        }
      </>
    );
  }
}
